export default theme => ({
  root: {
    width: 'auto',
    minWidth: 121,
  },
  buttonNav: {
    width: 121,
    minWidth: 121,
    paddingLeft: theme.spacing(["4", 2]),
    paddingRight: theme.spacing(["4", 2]),

    '&.MuiButton-sizeSmall': {
      paddingLeft: theme.spacing(["4", 1]),
      paddingRight: theme.spacing(["4", 1]),
    },

    '&.MuiButton-sizeLarge': {
      paddingLeft: '0px',
      paddingRight: '0px',
    },
  },
  startIcon: {
    display: 'inherit',
    marginRight: 8,
    marginLeft: -4,
  },
  endIcon: {
    display: 'inherit',
    marginRight: -4,
    marginLeft: 8,
  },
  iconSizeSmall: {
    '& > *:first-child': {
      // fontSize: theme.typography.pxToRem(18),
      fontSize: 18
    }
  },
  iconSizeMedium: {
    '& > *:first-child': {
      // fontSize: theme.typography.pxToRem(20),
      fontSize: 20
    }
  },
  iconSizeLarge: {
    '& > *:first-child': {
      // fontSize: theme.typography.pxToRem(22),
      fontSize: 22
    }
  },
  label:{
    pointerEvents: 'none'
  }
});